module.exports = __webpack_public_path__ + "static/media/rd-giftcard-new.c3ccae5c.png";